// src/services/apiConfig.js

// Determinar si usamos modo mock (solo en desarrollo)
export const USE_MOCK_API = process.env.VUE_APP_USE_MOCK === 'true';

// Importar servicios según el modo
let apiService;
if (USE_MOCK_API && process.env.NODE_ENV !== 'production') {
  // Solo cargar mock en desarrollo para no incluirlo en el bundle de prod
  apiService = require('@/services/mockApi').default;
  console.log('🧪 [API] Usando MOCK MODE para pruebas locales');
} else {
  apiService = require('@/services/api').default;
  console.log('🌐 [API] Usando API REAL en:', process.env.VUE_APP_API_BASE_URL);
}

export default apiService;